import detail from "./detail"
import list from "./list"
import benefits from "./benefits"

export default {
	...detail,
	...list,
	...benefits
}
